export default {
  application: {
    domain: "vetdirect.b2b.aox.pl"
    // domain: "rodan.b2b.aox.pl"
    // domain: "debug.rest.b2b.aox.pl",
  },

  header: {
    top: {
      message: "VETDIRECT SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ",
      links: [
        {
          text: "Promocje",
          router: {
            name: "showPage",
            params: { type: "STATIC_05E0B1F26D039C5550FDAC1BB8ABA611" }
          }
        },
        {
          text: "Informacje dla kupujących",
          router: {
            name: "showPage",
            params: { type: "STATIC_CAE5016A431D0473A05DB0174E0BD5DD" }
          }
        },
        {
          text: "Regulamin",
          router: {
            name: "showPage",
            params: { type: "STATIC_E9638E5CA020590645449B7DF00D40C9" }
          }
        }
      ]
    },
    main: {
      logo: "https://sample.redbay.pl/vetdirect/logo.jpg"
    }
  },
  searchPage: {
    optionsLimit: [20, 40, 100],
    visibleAttributes: ["SYMBOL_PRODUCENTA"],
    filters: {
      attributes: []
    }
  },
  productPage: {
    visibleAttributes: [
      "SYMBOL_PRODUCENTA",
      "SYMBOL_TOWARU",
      "Grubość blachy",
      "Kolor",
      "IDP_TOWARU",
      "IDP_WZORCA"
    ]
  },
  welcomePage: {
    enabled: true,
    messages: [{ id: 1, value: "Witamy w Vetdirect" }]
  },
  offer: {
    enable: false
  },
  demo: {
    enable: true
  },
  basket: {
    units: {
      single: [
        "szt",
        "szt.",
        "sztuka",
        "mb",
        "m",
        "g",
        "kpl",
        "usł",
        "op.",
        "kart.",
        "ryza"
      ],
      decimals: ["rol", "rol.", "km", "cm"]
    }
  }
};



// WEBPACK FOOTER //
// ./src/settings.js